// extracted by mini-css-extract-plugin
export var button = "_mv-0";
export var donut = "_mv-1";
export var donutFill = "_mv-3";
export var donutTrack = "_mv-2";